/* libs/shared/src/lib/ui/form/form.component.scss */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}
.submit-button {
  margin: 0;
  border: 1px solid transparent;
  border-radius: 7px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
}
.submit-button.primary {
  background: var(--primary-color);
  color: #fff;
}
.submit-button.primary:hover {
  background: var(--primary-color-hover);
}
.submit-button.ghost {
  background: #fff;
  color: var(--text-primary);
  border-color: var(--background-border);
}
.submit-button.ghost:hover {
  background: #f9fafb;
}
/*# sourceMappingURL=form.component.css.map */
